module.exports = "/images/download_report_black.svg?79cc3526a8f352a4eddd34f2ce31968c";